import { ControlIcons } from 'owa-control-icons';

/**
 * gets the icon name for the given place type
 * @param placeType: the place type, public place, room, private or unknown
 */
export default function getLocationCardIconName(placeType: string): string {
    switch (placeType) {
        case 'Room':
            return ControlIcons.Room;
        case 'PublicPlace':
            return ControlIcons.MapPin;
        case 'PersonalPlace':
            return ControlIcons.Home;
        default:
            return ControlIcons.Poi;
    }
}
